import { createContext, useContext } from "react";
import type { OperationalClock, Workspace } from "./model";
import type { DemoScenarioId } from './fixtures';
import type { WorkspaceBackup, WorkspaceBackupSummary } from './repository';
import type { PracticeChapterId, TutorialRun } from './practice';
export interface WorkspaceContextValue {
  state: Workspace;
  ready: boolean;
  error: string;
  dispatch: (type: string, payload?: Record<string, unknown>) => Promise<void>;
  clearError: () => void;
  reload: () => Promise<void>;
  drainPending: () => Promise<void>;
  readCurrent: () => Workspace;
  clock: OperationalClock;
  actorId: string;
  setActorId: (actorId: string) => void;
  listBackups: () => Promise<WorkspaceBackupSummary[]>;
  getBackup: (id: string) => Promise<WorkspaceBackup>;
  restoreBackup: (id: string) => Promise<void>;
  resetDemo: (scenarioId?: DemoScenarioId) => Promise<void>;
  practiceRun: TutorialRun | null;
  startPractice: (chapter:PracticeChapterId,returnRoute:string) => Promise<void>;
  resumePractice: (runId:string) => Promise<void>;
  restartPractice: (chapter:PracticeChapterId) => Promise<void>;
  exitPractice: () => Promise<void>;
  updatePracticeRun: (update:(run:TutorialRun)=>TutorialRun) => Promise<void>;
  listPracticeRuns: () => Promise<TutorialRun[]>;
  createPracticeBackup: () => Promise<WorkspaceBackup>;
  failPracticeSave: () => void;
}
export const WorkspaceContext = createContext<WorkspaceContextValue | null>(
  null,
);
export function useWorkspace(): WorkspaceContextValue {
  const value = useContext(WorkspaceContext);
  if (!value) throw new Error("WorkspaceProvider is required.");
  return value;
}
